"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PanelContainer = void 0;
var React = __importStar(require("react"));
var ScalePanel_1 = require("./Panels/ScalePanel");
var TextPanel_1 = require("./Panels/TextPanel");
var SignaturePanel_1 = require("./Panels/SignaturePanel");
var types_1 = require("./types");
var Context_1 = require("./Context");
function PanelContainer(props) {
    var artwork = props.artwork;
    var ctx = React.useContext(Context_1.GlobalContext);
    var canvasTexts = ctx.canvasTexts, handleSetFontFill = ctx.handleSetFontFill, handleSelectedText = ctx.handleSelectedText, selectedPanel = ctx.selectedPanel;
    return (React.createElement(React.Fragment, null,
        selectedPanel === types_1.PanelNames.Scale && React.createElement(ScalePanel_1.ScalePanel, null),
        selectedPanel === types_1.PanelNames.Text && React.createElement(TextPanel_1.TextPanel, null),
        selectedPanel === types_1.PanelNames.Signature && React.createElement(SignaturePanel_1.SignaturePanel, null)));
}
exports.PanelContainer = PanelContainer;
